import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { withStyles, Tooltip } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import HelpIcon from '@material-ui/icons/Help';
import { getI18nFormattedMessage } from '../../../../utils/intl';
import prettyCron from '../../../../utils/prettycronOverride';
import ExpandableList from '../../../../components/ExpandableList';

import styles from './styles';


const DetailCardRaw = ({
    details,
    title,
    titleIcon,
    totalCount,
    selectedCount = 0,
    selectedList = [],
    keySyncLog,
    keySyncTime,
    keySyncDisruption,
    lastSyncErrorMsg,
    displayLastSync = true,
    displayProxyCount = true,
    displayPortalCount = true,
    displaySelectedList = false,
    featureFlag = true,
    isApiCard = false,
    emptyResultsText = '',
    classes,
  }) => {
  const syncTime = get(details, keySyncTime);
  const validSyncTime = syncTime !== null && syncTime !== '0';
  const lastSyncDateTime = validSyncTime
                            ? new Date(parseInt(syncTime, 10)).toString()
                            : lastSyncErrorMsg;

  const syncLog = get(details, keySyncLog);
  const validSyncLog = syncLog && syncLog !== null;
  const cronSyncErrorMsg = '';
  const cronText = validSyncLog
                    ? prettyCron.toString(JSON.parse(syncLog).cron)
                    : cronSyncErrorMsg;

  const portalCount = totalCount;
  const proxyCount = selectedCount || (validSyncLog ? JSON.parse(syncLog).count : 0);

  const syncDisruption = get(details, keySyncDisruption) !== null
                          ? get(details, keySyncDisruption)
                          : 0;
  const outSync = (parseInt(syncDisruption, 10) === 1) ||
                    !(parseInt(portalCount, 10) === parseInt(proxyCount, 10));
  const outSyncDateTime = moment(new Date(parseInt(syncTime, 10))).fromNow(true);

  return (
    <Card data-apim-test="proxy-detail-card" className={classes.card}>
      <CardContent>
        <Typography component={'h3'} className={classes.title} gutterBottom>
          <span className={classes.titleIcon}>{titleIcon}</span>
          <span className={classes.titleText}>{title}</span>
        </Typography>
        <Divider className={classes.divider} />
        {featureFlag ?
          <Fragment>
            {displayLastSync &&
              <Fragment>
                <Typography component={'div'} className={classes.lastSync}>
                  <span className={classes.iconStatus}>
                    {outSync
                      ? <CloseIcon className={classes.errorIconRoot} />
                      : <CheckIcon className={classes.successIconRoot} />
                    }
                  </span>
                  <span className={classes.iconStatusText}>Last sync: {lastSyncDateTime}</span>
                  {(validSyncTime && outSync)
                    && <span className={classes.lastSyncWarning}>→ {outSyncDateTime} {'since last sync'}</span>}
                </Typography>
                {cronText &&
                  <Typography className={classes.lastSyncDescription}>
                    <span>{'Syncing every'} {cronText}</span>
                  </Typography>
                }
              </Fragment>
            }
            {displayPortalCount &&
              <Typography component={'div'} className={classes.description}>
                <span className={classes.iconStatus}><CheckIcon style={{ fontSize: 16, color: 'green' }} /></span>
                <span className={classes.iconStatusText}>Portal: {portalCount}</span>
                {isApiCard && displayLastSync &&
                  <Tooltip title={getI18nFormattedMessage('label.proxy.details.api.old.card.helptext')} arrow placement="right">
                    <HelpIcon className={classes.helpIcon} />
                  </Tooltip>
                }
              </Typography>
            }
            {displayProxyCount &&
              <Typography component={'div'} className={classes.description}>
                <span className={classes.iconStatus}>
                  {outSync
                    ? <CloseIcon className={classes.errorIconRoot} />
                    : <CheckIcon className={classes.successIconRoot} />
                  }
                </span>
                <span className={classes.iconStatusText}>Proxy: {proxyCount}</span>
              </Typography>
            }
            {displaySelectedList &&
              <Typography component={'div'} className={classes.description}>
                <ExpandableList list={selectedList} title={'Organizations'} />
              </Typography>
            }
          </Fragment>
          :
          <Typography component={'div'} className={classes.lastSync}>
            {emptyResultsText}
          </Typography>
        }
      </CardContent>
    </Card>
  );
};

DetailCardRaw.propTypes = {
  details: PropTypes.shape({}),
  title: PropTypes.string,
  titleIcon: PropTypes.node,
  totalCount: PropTypes.number,
  selectedCount: PropTypes.number,
  selectedList: PropTypes.arrayOf(PropTypes.shape({})),
  keySyncLog: PropTypes.string,
  keySyncTime: PropTypes.string,
  keySyncDisruption: PropTypes.string,
  lastSyncErrorMsg: PropTypes.string,
  displayLastSync: PropTypes.bool,
  displayProxyCount: PropTypes.bool,
  displayPortalCount: PropTypes.bool,
  displaySelectedList: PropTypes.bool,
  featureFlag: PropTypes.bool,
  emptyResultsText: PropTypes.string,
  classes: PropTypes.shape({}),
  isApiCard: PropTypes.bool,
};

DetailCardRaw.displayName = 'DetailCard';

export default withStyles(styles)(DetailCardRaw);



// WEBPACK FOOTER //
// ./src/pages/ApiProxy/Details/DetailCard/index.js